import { useEffect } from 'react';
import { Link as RouterLink, useRouteError } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import RefreshRounded from '@mui/icons-material/RefreshRounded';
import { Reveal } from '../design/motion';
import { GlassPanel, Kicker } from '../design/surfaces';
import { color } from '../design/tokens';

/**
 * Shown in place of a page that crashed, inside the app's header, instead of React Router's developer screen.
 * Everything saved is still there: a reload brings the page back.
 */
export function RouteError() {
    const error = useRouteError();
    useEffect(() => { console.error(error); }, [error]);

    return (
        <Box sx={{ flex: 1, display: 'grid', placeItems: 'center', p: 2 }}>
            <Reveal>
                <GlassPanel corners sx={{ maxWidth: 460, p: { xs: 3, sm: 4.5 }, textAlign: 'center' }}>
                    <Box sx={{
                        mx: 'auto', mb: 2.5, width: 56, height: 56, display: 'grid', placeItems: 'center',
                        borderRadius: '50%', color: color.spark, backgroundColor: color.sparkSoft,
                        boxShadow: `0 0 40px -6px ${color.spark}88`,
                        '& svg': { fontSize: 28 },
                    }}>
                        <RefreshRounded />
                    </Box>
                    <Kicker sx={{ justifyContent: 'center', mb: 1 }}>Something broke</Kicker>
                    <Typography variant="h4" sx={{ mb: 1.5, fontSize: { xs: 26, sm: 30 } }}>This page tripped up</Typography>
                    <Typography color="text.secondary" sx={{ mb: 3 }}>Your work is saved. Reload to continue.</Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
                        <Button variant="contained" onClick={() => window.location.reload()}>Reload</Button>
                        <Button variant="outlined" component={RouterLink} to="/" reloadDocument>Go to CoSparks</Button>
                    </Stack>
                </GlassPanel>
            </Reveal>
        </Box>
    );
}
